import { useState } from 'react';
import { useAppStore } from '../../store/appStore';
import { CHARACTER_ORDER } from './characters_icon/CharacterIcon';
import {
  createSelectCharacterScreenModel,
  type SelectCharacterScreenProps,
} from './SelectCharacterScreenModelScreen';
import { SelectCharacterScreenController } from './SelectCharacterScreenController';
import { SelectCharacterScreenView } from './SelectCharacterScreenView';

export type { SelectCharacterScreenProps } from './SelectCharacterScreenModelScreen';

function initialSelectedIndex(): number {
  const courierId = useAppStore.getState().selectedCourierId;
  if (courierId == null) {
    return 0;
  }
  const index = CHARACTER_ORDER.indexOf(courierId);
  return index >= 0 ? index : 0;
}

export function SelectCharacterScreen(props: SelectCharacterScreenProps = {}) {
  const [selectedIndex, setSelectedIndex] = useState(initialSelectedIndex);
  const model = createSelectCharacterScreenModel(props, {
    selectedIndex,
    setSelectedIndex,
  });
  const controller = new SelectCharacterScreenController(model);

  return <SelectCharacterScreenView model={model} controller={controller} />;
}
